document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('section.four-pillars')
	const testimonialSliderEl = section.querySelector('.keen-slider')
	const centerSvg = section.querySelector('.center svg')
	const centerSvgPaths = section.querySelectorAll('.center svg path')
	const textContents = section.querySelectorAll('.text-content')
	const before = section.querySelector('.before')
	const after = section.querySelector('.after')
	var carousel = new KeenSlider(
		testimonialSliderEl,
		{
			loop: true,
			slides: {
				perView: 1,
				spacing: 24,
			},
		},
		[navigation]
	)

	before.addEventListener('click', () => {
		carousel.prev()
	})

	after.addEventListener('click', () => {
		carousel.next()
	})

	document.addEventListener('keydown', e => {
		if (!section.contains(document.activeElement)) return
		if (e.key === 'ArrowLeft') { e.preventDefault(); carousel.prev() }
		else if (e.key === 'ArrowRight') { e.preventDefault(); carousel.next() }
	})

	const updatePathFocus = (idx) => {
		centerSvgPaths.forEach((p, i) => {
			if (i === idx) {
				p.classList.add('active')
			} else {
				p.classList.remove('active')
			}
		})
	}
	const updateTextContentFocus = (idx) => {
		textContents.forEach((text, i) => {
			text.classList.remove('initial-focus') //remove pageload state with text hidden
			if (i === idx) {
				text.classList.add('active')
			} else {
				text.classList.remove('active')
			}
		})
	}

	centerSvgPaths.forEach((path, idx) => {
		path.addEventListener('touchstart', () => {
			path.focus()
			carousel.moveToIdx(idx)
			updatePathFocus(idx)
			updateTextContentFocus(idx)
		})
		path.addEventListener('focus', () => {
			carousel.moveToIdx(idx)
			updatePathFocus(idx)
			updateTextContentFocus(idx)
		})
	})

	carousel.on('slideChanged', () => {
		updatePathFocus(carousel.track.details.rel)
		updateTextContentFocus(carousel.track.details.rel)
	})

	// paragraph stuff

	let innerWidth = window.innerWidth
	let tallest = 0;
	// initial set
	if (innerWidth >= 1200) {
		textContents.forEach(text => {
			if (text.scrollHeight > tallest) {
				tallest = text.scrollHeight;
			}
			const p = text.querySelector('p')
			p.style.setProperty('--paragraph-height', `${p.scrollHeight}px`)
		})
		if (centerSvg.scrollHeight > tallest * 2) {
			tallest = centerSvg.scrollHeight / 2;
		}
		section.style.setProperty('--row-height', `${tallest}px`);
	}
	// dynamic set on resize
	window.addEventListener('resize', () => {
		innerWidth = window.innerWidth
		if (innerWidth >= 1200) {
			textContents.forEach(text => {
				const p = text.querySelector('p')
				p.style.setProperty('--paragraph-height', `${p.scrollHeight}px`)
			})
		}
	})
})
// end of paragraph stuff

// slider navigation
function navigation(slider) {
	let wrapper = document.querySelector('.pillars .controls')
	let dots
	function markup(remove) {
		dotMarkup(remove)
	}
	function removeElement(element) {
		element.parentNode.removeChild(element)
	}
	function createDiv(className) {
		var div = document.createElement('div')
		var classNames = className.split(' ')
		classNames.forEach(name => div.classList.add(name))
		return div
	}
	function dotMarkup(remove) {
		if (remove) {
			removeElement(dots)
			return
		}
		dots = createDiv('dots')
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv('dot')
			dot.addEventListener('click', () => {
				idx =
					idx > slider.track.details.maxIdx ? slider.track.details.maxIdx : idx
				slider.moveToIdx(idx)
			})
			dots.appendChild(dot)
		})

		wrapper.appendChild(dots)
	}

	function updateClasses() {
		var slide = slider.track.details.rel
		const slides = document.querySelectorAll(
			'.pillars .keen-slider .keen-slider__slide'
		)
		Array.from(dots.children).forEach(function (dot, idx) {
			if (idx === slide && window.innerWidth < 768) {
				dot.classList.add('dot--active')
				slides[slide].classList.add('active')
			} else {
				dot.classList.remove('dot--active')
				slides[idx].classList.remove('active')
			}
		})
	}

	slider.on('created', () => {
		markup()
		updateClasses()
	})
	slider.on('optionsChanged', () => {
		markup(true)
		markup()
		updateClasses()
	})
	slider.on('slideChanged', () => {
		updateClasses()
	})
	slider.on('destroyed', () => {
		markup(true)
	})
	window.addEventListener('resize', () => {
		updateClasses()
	})
}
